var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAdditem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "CurrentIconColor2",
    d: "M13.93 5.43V6.77C11.31 6.98 9.82 8.66 9.82 11.43V16H5.93C3.64 16 2.5 14.86 2.5 12.57V5.43C2.5 3.14 3.64 2 5.93 2H10.5C12.79 2 13.93 3.14 13.93 5.43Z",
    fill: "#586572"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "CurrentIconColor2",
    d: "M19.0701 8H14.5001C12.2101 8 11.0701 9.14 11.0701 11.43V18.57C11.0701 20.86 12.2101 22 14.5001 22H19.0701C21.3601 22 22.5001 20.86 22.5001 18.57V11.43C22.5001 9.14 21.3601 8 19.0701 8ZM18.6301 15.75H17.7501V16.63C17.7501 17.04 17.4101 17.38 17.0001 17.38C16.5901 17.38 16.2501 17.04 16.2501 16.63V15.75H15.3701C14.9601 15.75 14.6201 15.41 14.6201 15C14.6201 14.59 14.9601 14.25 15.3701 14.25H16.2501V13.37C16.2501 12.96 16.5901 12.62 17.0001 12.62C17.4101 12.62 17.7501 12.96 17.7501 13.37V14.25H18.6301C19.0401 14.25 19.3801 14.59 19.3801 15C19.3801 15.41 19.0401 15.75 18.6301 15.75Z",
    fill: "#586572"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditem);
export default __webpack_public_path__ + "static/media/additem.67654f413057f46f45a70ee689fc5b3b.svg";
export { ForwardRef as ReactComponent };